<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-button type="primary" @click="handleAdd">新增</el-button>
		</el-col>

		<!--列表-->
		<el-table stripe :data="datalist" highlight-current-row v-loading="listLoading" style="width: 100%;" height="900">
			<el-table-column type="index" label="编号" width="60">
			</el-table-column>
			<el-table-column prop="name" label="姓名" width="120" >
			</el-table-column>
			<el-table-column prop="remark" label="描述" width="120">
				<template scope="scope">
					{{scope.row.remark}}:{{formatType(scope.row.type)}}
				</template>
			</el-table-column>
			<el-table-column prop="view_menu_nos" label="菜单编码" width="600" :formatter="formatMenus">
			</el-table-column>
			<el-table-column label="操作" width="150">
				<template scope="scope">
					<el-button type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="text" @click="handleDel(scope.$index, scope.row)" icon="el-icon-delete"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--编辑界面-->
		<el-dialog :title="editformtitle" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="formRules" ref="editForm">
				<el-form-item label="姓名" prop="name" style="width: 400px;">
					<el-input v-model="editForm.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="描述" prop="remark" style="width: 400px;">
					<el-input v-model="editForm.remark" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="权限类型" class="is-required">
					<el-select v-model="editForm.type" placeholder="请选择权限类型">
						<el-option label="系统权限" value="1"></el-option>
						<el-option label="业务员权限" value="2"></el-option>
						<el-option label="企业用户权限" value="3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="菜单编码" prop="view_menu_nos">
					<el-tree
					  :data="treeMenusData"
					  show-checkbox
					  default-expand-all
					  node-key="value"
					  ref="tree"
					  highlight-current
					  :props="editForm.view_menu_nos">
					</el-tree>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	//import NProgress from 'nprogress'
	import { getListPage, delData, saveData } from '../../api/api';

	export default {
		data() {
			return {
				treeMenusData: [],
				datalist: [],
				total: 0,//总记录数
				pagesize:2000,//每页条数
				page: 1,//默认第几页
				listLoading: false,
				////
				menu_options:[],
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					menuno: [
						{ required: true, message: '请输入菜单编号', trigger: 'blur' }
					],
					menuname: [
						{ required: true, message: '请输入菜单名称', trigger: 'blur' }
					]
				},
				//编辑界面数据
				editForm: {
					actionurl:'',
					sqlid:'',
					id:0,
					name: '',
					remark:'',
					view_menu_nos:'',type:''		
				}
			}
		},
		methods: {
			formatType(type){
				if(type=='1') return '系统权限';
				if(type=='2') return '业务员权限';
				if(type=='3') return '企业用户权限';
				return '未设置';
			},
			getCheckedKeys() {
				var treeList = this.$refs.tree.getCheckedKeys();
				treeList.forEach(function(d){
					console.log(d);
				});
				
			  },
			handleCurrentChange(val) {
				this.page = val;
				this.getLists();
			},
			formatMenus:function(row,column){
				return row.view_menu_nos;
				/**
				var restr = '' ;
				var index =0 ;
				this.menu_options.forEach(function(d){
					if(row.view_menu_nos.indexOf(d.value+',')>=0){
						restr += d.label + '  ';
						index ++ ;
						console.log('>?>>'+index);
						if(index%4==0) {
							restr += '\r\n';
							console.log('>?>>'+index);
						}
					}
				});
				console.log(restr);
				return restr;
				*/
			},
			//获取菜单选择框
			getMenuOptions(){
				let para = {
					actionurl:'default/getMenuTreeList',
					sqlid:'selectOptions.menu_options',
				};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						//this.menu_options = res.data.datas;
						//////////////////////
						//data2
						this.treeMenusData = res.data.datas;
					}
				});
				
			},
			//获取用户列表
			getLists() {
				let para = {
					actionurl:'default/getListAll',
					sqlid:'roles.queryconf',
				};
				this.listLoading = true;
				//NProgress.start();
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					
					this.listLoading = false;
					//NProgress.done();
				});
			},
			//删除
			handleDel: function (index, row) {
				let para = { 
					id: row.id,
					actionurl:'default/del',
					sqlid:'roles.delconf'
				};
				util.deleteFunction(this,para);
			},
			showSelectTree:function(){
				if(this.editForm.view_menu_nos==''){
					this.$refs.tree.setCheckedKeys([]);
				}else{
					var checkMeunstr = this.editForm.view_menu_nos.split(',');
					this.$refs.tree.setCheckedKeys(checkMeunstr);
				}
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				console.log("actionurl="+this.editForm.actionurl);
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'roles.uptconf';//设置Sqlid
				setTimeout(this.showSelectTree, 20);
			},
			//显示新增界面
			handleAdd: function () {
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',
					sqlid:'roles.addconf',
					id:0,
					name: '',
					remark:'',
					view_menu_nos:''
				};
				this.$refs.tree.setCheckedKeys([]);
			},
			//编辑保存
			editSubmit: function () {
				let para = Object.assign({}, this.editForm);
				var menusstr = '';
				var treeList = this.$refs.tree.getCheckedKeys();
				treeList.forEach(function(d){
					menusstr += d + ',';
				});
				if(menusstr.length>1) menusstr=menusstr.substring(0,menusstr.length-1);
				para.view_menu_nos = menusstr;
				util.saveFunction(this,para);
			}
		},
		mounted() {
			this.getMenuOptions();
			this.getLists();
		}
	}
</script>

<style scoped>
.el-table .cell {
  white-space: pre-line;
}
</style>


// WEBPACK FOOTER //
// Roles.vue?6d2e9140